import { render } from "./goodsServerItemTmp.vue?vue&type=template&id=29c74a38"
import script from "./goodsServerItemTmp.vue?vue&type=script&lang=js"
export * from "./goodsServerItemTmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__